/** Semantic row class for billable tests. Colors are defined in SCSS only (adminTestList tr.billable). */
export function billableRowClass(billable?: boolean | null): string {
  return billable ? "billable" : "";
}

/** Semantic row class for archived tests. Colors are defined in SCSS only (adminTestList tr.archived). */
export function archivedRowClass(archived?: boolean | null): string {
  return archived ? "archived" : "";
}

type TestCodeUsability = {
  finished?: string | null;
  code?: string | null;
  codeActive?: boolean | null;
  codeExpiration?: string | null;
};

/**
 * Incomplete tests whose personal code is inactive or past expiration.
 * SCSS: adminTestList tr.codeUnusable
 */
export function unusableCodeRowClass(
  test: TestCodeUsability | null | undefined,
  now: Date = new Date()
): string {
  if (!test || test.finished) {
    return "";
  }
  if (!test.code) {
    return "";
  }
  if (test.codeActive === false) {
    return "codeUnusable";
  }
  if (test.codeExpiration) {
    const exp = Date.parse(String(test.codeExpiration));
    if (!Number.isNaN(exp) && exp < now.getTime()) {
      return "codeUnusable";
    }
  }
  return "";
}

/** Join semantic row class names; never use for inline styles. */
export function testTableRowClass(...parts: (string | false | null | undefined)[]): string {
  return parts.filter(Boolean).join(" ");
}
